export default "__VITE_ASSET__b3df5e41__"